import React from "react";

import ViewMore from "./viewMore";
import { Link, useParams } from "react-router-dom";
import { TextBoldBase } from "../../../Components/Text/BoldText";
import { FaPaperclip } from "react-icons/fa";
// import PaperClip from "../../../../assets/images/paper-clip.png";

export default function NoteCard({ data, getNotes, id }) {
  const {officeId} = useParams();
  let { title, description, reminder_time, reminder_date, attachments } = data;

  function CompareTime(date, time) {
    let DateNow = new Date();
    let x = new Date(`${date},${time}`);
    if (x >= DateNow) {
      if (x.getTime() >= DateNow.getTime()) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  // CompareTime()

  let AttachmentList = attachments;
  return (
    <>
      <div
        className="w-full lg:w-[23%] h-[150px] m-2 md:w-[30%] px-4 py-2 bg-white shadow-md border-blue-100 border hover:shadow-[0px_4px_16px_rgba(17,17,26,0.1),_0px_8px_24px_rgba(17,17,26,0.1),_0px_8px_24px_rgba(17,17,26,0.1)] rounded-[10px]  mt-4"
        style={{border:'1px solid #dedede'}}
      >
        <div className="w-full flex justify-between ">
          <div className=" overflow-hidden truncate">
            {data.status && (
              <div
                className={`text-xs text-white font-medium py-[2px] px-[6px] rounded-[5px] ${
                  data?.status.toLowerCase() == "completed" ||
                  data?.status.toLowerCase() == "complete" ||
                  data?.status.toLowerCase() == "finished" ||
                  data?.status.toLowerCase() == "finished" ||
                  data?.status.toLowerCase() == "close" ||
                  data?.status.toLowerCase() == "closed"
                    ? "bg-[#00CC5E]"
                    : data?.status.toLowerCase() == "pending"
                    ? "bg-[#D2BD00] "
                    : "bg-[#048178]"
                }`}
              >
                {data.status || ""}
              </div>
            )}
          </div>

          <div className="flex items-center gap-4">
            <div className=" flex justify-center items-center">
              {AttachmentList?.length > 0 ? (
                <div className=" w-[17px] h-[17px] overflow-hidden">
                  {/* <img src={PaperClip} alt="#" width="60%" /> */}
                  <p>
    <FaPaperclip style={{ color: '#8D77AB', fontSize: '16px' }} /> 
</p>

                </div>
              ) : null}
            </div>
            <div className=" flex justify-center items-center">
              {(reminder_date != "" ||
                (reminder_time != "00:00:00" && reminder_time != "")) &&
              CompareTime(reminder_date, reminder_time) ? (
                <svg
                  className="w-[17px] h-[17px] fill-[#C5C900]"
                  xmlns="http://www.w3.org/2000/svg"
                  height="1em"
                  viewBox="0 0 512 512"
                >
                  <path d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" />
                </svg>
              ) : (
                <p> </p>
              )}
            </div>
            <ViewMore
              // positionTestList={positionList}
              data={data}
              getNotes={getNotes}
              id={id}
            />
          </div>
        </div>
        <div className=" w-full overflow-hidden truncate">
          <Link to={`/dairy/view/${id}`}>
            <p className="text-blue-700 text-sm">{title || "-"}</p> 
          </Link>
        </div>
        <div className=" w-full overflow-hidden">
          <pre className="text-textColor-300 my-2 text-xs overflow-hidden line-clamp-4 whitespace-pre-wrap">
            {description || "-"}
          </pre>
        </div>
      </div>
    </>
  );
}
